import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import Page from '../../components/Page';
import Breadcrumb from '../../components/breadcrumb/BreadCrumb';
import { WD, FONT_SERIF } from './warningTheme';
import ConfigScreenContext from './ConfigScreenContext';
import WhoCanSet from './WhoCanSet';

// Drop-in replacement for GlobalWrapper on every Warning Dashboard screen (same title/actions/children
// props): eyebrow + serif title + actions on one row, breadcrumb under it, then the content. Differs from
// GlobalWrapper on purpose - no artificial 1s skeleton delay before content shows (screens already show their
// own loading state while fetching) and a short CSS fade instead of the user-configurable slide/collapse.
const WarningPage = ({ title, actions, children }) => {
  const configScreen = useContext(ConfigScreenContext); // set on a threshold screen only
  return (
  <Page title={title}>
    <Box maxWidth={2000}>
      <Box display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={2}>
        <Box sx={{ minWidth: 0 }}>
          {/* eyebrow naming the module - left out on the home page, whose title is the module name itself */}
          {title !== 'Warning Dashboard' && <Typography sx={{ fontSize: 13, fontWeight: 600, color: WD.green }}>Warning Dashboard</Typography>}
          <Typography component="h1" sx={{ fontFamily: FONT_SERIF, fontSize: { xs: 24, md: 32 }, fontWeight: 600, lineHeight: 1.2, color: WD.ink, mt: 0.25 }}>
            {title}
          </Typography>
          <Breadcrumb sx={{ paddingLeft: 0.5 }} />
          {configScreen && <WhoCanSet config={configScreen.config} />}
        </Box>
        <Box>{actions}</Box>
      </Box>
      <Box
        sx={{
          mt: 3,
          animation: 'wdFadeUp 0.35s ease both',
          '@keyframes wdFadeUp': { from: { opacity: 0, transform: 'translateY(6px)' }, to: { opacity: 1, transform: 'none' } },
          '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
        }}
      >
        {children}
      </Box>
    </Box>
  </Page>
  );
};

export default WarningPage;
